interface Config {
  zero: boolean;
  false: boolean;
}

export class ValueUtil {
  static isEmpty(value: unknown, config: Config = { zero: false, false: false }) {
    return Array.isArray(value)
      ? !value.length
      : !value && (config.zero || value !== 0) && (config.false || value !== false);
  }

  static placeholderTooltip(placeholder: string, value: unknown) {
    if (typeof value === 'string') {
      return ValueUtil.isEmpty(value.trim()) ? undefined : placeholder;
    }

    return ValueUtil.isEmpty(value) ? undefined : placeholder;
  }
}
